@if(loadingSvc.loading()){
<div class="overlay">
    <div class="spinner-container">
        <div class="spinner"></div>
        <p class="loading-text">Cargando, por favor espera...</p>
    </div>
</div>
}